/* eslint-disable */
<template>
  <div>
    <div class="font-size-h3 font-weight-bold mt-3">Booking Summary</div>
    <div class="text-tertiary mb-2 text-center">
        <span>{{formattedStartDay}}</span>, <span>{{formattedStartDate}}</span><br/>
        <span>@ {{formattedStartTime}}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import { BookingDateTimeMixin } from '@/mixins/Booking/BookingDateTimeMixin';
  
  export default {
    name: 'DisplayHeader',
    mixins: [BookingDateTimeMixin]
  }
</script>